export const PAGE_TITLE = 'Citrus DEV'
export const PAGE_SIZE = 10
export const MIN_INTERVAL = '2'

export const PLAN_TYPE = {
  BEACONS_SUMMARY: 1,
  LJSDK_SUMMARY: 2,
}

export const PAGE_NAME = {
  DASHBOARD: 'TOP',
  INFO: 'お知らせ',
  ANALYTICS: 'アナリティクス',

  VISIT: '来店分析',
  USER_VISIT: 'アプリユーザ来訪分析',

  MEASURE: '施策分析',
  CHECK_IN_NOTIFICATION: 'チェックイン通知分析',
  CHECK_IN_STAMP: 'チェックインスタンプ分析',

  // CAMPAIGNS: 'キャンペーン',
  // CAMPAIGN_LIST: 'キャンペーンリスト'
}

export const API_PARAMS = {
  SELECT_ALL: '-1',
}

export const BREADCRUMBS_DICT: { [key: string]: string } = {
  // common
  dashboard: PAGE_NAME.DASHBOARD,
  info: PAGE_NAME.INFO,
  analytics: PAGE_NAME.ANALYTICS,

  // visit
  visit: PAGE_NAME.VISIT,
  'app-user': PAGE_NAME.USER_VISIT,

  // measure
  measure: PAGE_NAME.MEASURE,
  'check-in-notification': PAGE_NAME.CHECK_IN_NOTIFICATION,
  'check-in-stamp': PAGE_NAME.CHECK_IN_STAMP,

  // campaigns: PAGE_NAME.CAMPAIGNS,
  // 'campaign-list': PAGE_NAME.CAMPAIGN_LIST
}
